import { render, staticRenderFns } from "./Spine.vue?vue&type=template&id=01ff2da8"
import script from "./Spine.vue?vue&type=script&lang=js"
export * from "./Spine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports